<template>
  <div class="history-list">
    <van-cell-group>
      <van-cell :title="item.label" :value="item.value" v-for="item in list" :key="item" />
    </van-cell-group>

    <div style="font-size: 12px;margin-top: 10px;" class="rmk-txt">
      每学年可计入培训护照的充电保积分上限为500分
    </div>
  </div>
</template>

<script>
import '@/assets/_variable.scss'
import { getCdb } from '@/api/user/index.js'
export default {
  name: 'HistoryList',
  data() {
    return {
      list: [],
      PPN: '',
    }
  },
  created() {},
  methods: {
    getList() {
      getCdb({
        ppn: this.PPN,
      }).then((res) => {
        let label = Object.keys(res.data)[0]
        let value = Object.values(res.data)[0]
        this.list.push({
          label: label,
          value: value,
        })
      })
    },
  },
  mounted() {
    this.PPN = JSON.parse(localStorage.getItem('user')).ppn
    this.getList()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.history-list {
  padding: 20px;
}
</style>
